import { useEffect, useState } from "react";
import { api } from "../helpers/api";
import { config } from "../config";

export const useIpAddress = () => {
  const [ip, setIp] = useState<string>();

  useEffect(() => {
    api(config.isDevelopment ? "dev" : "us")
      .get<{ ipAddress: string }>("/screens/ip_address")
      .then((resp) => setIp(resp.data.ipAddress));
  }, []);

  return ip;
};
